import { Injectable, Inject, Optional, DOCUMENT } from "@angular/core";
import {
  CanActivateFn,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlSegment,
  Router,
} from "@angular/router";

import { TokenService } from "./token.service";
import { fetchAuthSession } from "@aws-amplify/auth";
const LOGIN_URL = "/auth/login";
@Injectable({
  providedIn: "root",
})
export class AuthGuard  {
    TokenID: any;
  private gotoLogin(url?: string) {
    setTimeout(() => {
      if (/^https?:\/\//g.test(url)) {
        this.document.location.href = url;
      } else {
        this.router.navigateByUrl(url);
      }
    });
  }
  private checkJWT(model: any, offset?: number): boolean {
    return !!model;
  }
    private async process(): Promise<boolean> {
        await this.getTokenID();

        const res = this.checkJWT(this.TokenID, 1000);
    if (!res) {
      this.gotoLogin(LOGIN_URL);
    }
    return res;
    }
    async getTokenID() {
        let tokenID: any = '';
        const session = await fetchAuthSession();
        if (session?.tokens) {
            tokenID = session.tokens.idToken?.toString();
        }
        this.TokenID = tokenID;
    }
  constructor(
    private readonly router: Router,
     // private readonly token: TokenService,
      @Optional() @Inject(DOCUMENT) private readonly document: any
  ) {
     // this.getTokenID();
  }
    canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    return this.process();
  }
  canActivate: CanActivateFn = (
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) => {
        return this.process();
    };
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.process();
  }
}